<template>
    <b-row>
        <b-col cols="3"></b-col>
        <b-col cols="6">
            <b-card header-bg-variant="primary" 
                    header-text-variant="white"
                    footer-bg-variant="white" 
                    border-variant="primary"
                    align="center">
                <h6 slot="header" class="mb-0">{{ $t('project.invitation.title') }}</h6>
                <b-card-body v-if="inviteInfo">
                    <p>{{ $t('project.invitation.description') }} - <strong>{{ inviteInfo.projectInfo.name }}</strong></p>
                    <p>{{ $t('project.invitation.question') }}</p>
                </b-card-body>
                <div slot="footer">
                    <b-row>
                        <b-col cols="6">
                            <b-btn variant="outline-success" block
                                   @click="acceptInvitation">{{ $t('general.yes') }}
                            </b-btn>
                        </b-col>
                        <b-col cols="6">
                            <b-btn variant="outline-danger" block
                                   @click="declineInvitation">{{ $t('general.no') }}
                            </b-btn>
                        </b-col>
                    </b-row>
                </div>
            </b-card>
        </b-col>
        <b-col cols="3"></b-col>
    </b-row>
</template>

<script>
import {mapState} from 'vuex';
import systemApi from '../api/system';

export default {
    computed: {
        ...mapState('system', ['inviteInfo']),
        
        inviteToken() {
            return this.$route.params.token;
        }
    },

    beforeRouteEnter (to, from, next) {
        systemApi.loadInviteInfo(to.params.token)
            .then((res) => {
                if (res.data.message === 'redirect_to_project') {
                    let projectId = res.data.projectInfo.id;
                    next({ name: 'project-home', params: { projectId, membership: true } });
                } else {
                    next(vm => vm.$store.dispatch('system/loadInviteInfo', vm.inviteToken));
                }
            })
            .catch(() => next({name: 'error-page'}));
    },

    methods: {
        acceptInvitation() {
            this.$store.dispatch('system/redeemInvite', this.inviteToken)
                .then(() => {
                    this.$store.dispatch('system/setInvite', this.inviteToken);
                    this.$cookie.delete('EPR_INVITE');

                    let projectId = this.inviteInfo.projectInfo.id;
                    this.$router.push({name: 'project-home', params: { projectId, membership: 'true' }});
                });
        },

        declineInvitation() {
            if (this.$cookie.get('EPR_INVITE')) {
                this.$cookie.delete('EPR_INVITE');
            }
            this.$router.push({ name: 'dashboard' });
        }
    }
}
</script>
